import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom'

import { useTranslation } from 'react-i18next';
import EnglishResourceBundle from './locale/consent.en.json'
import FrenchResourceBundle from './locale/consent.fr.json'

export const Consent = props => {
    const { t, i18n } = useTranslation();
    i18n.addResourceBundle('en', 'consent', EnglishResourceBundle);
    i18n.addResourceBundle('fr', 'consent', FrenchResourceBundle);

    const { clientKey, context, data, termsChanged } = props;
    const [state, setState] = useState({ clientIsInvalid: true, formIsInvalid: true });
    const clientRef = useRef(null);
    const formRef = useRef(null);

    const getLocalizeValue = (obj, culture, name) => {
        let localizeObj = obj && obj[culture.substring(0, 2)] ? obj[culture.substring(0, 2)] : null;

        if (localizeObj == null) {
            const keys = Object.keys(obj);
            if (keys.length > 0)
                localizeObj = obj[keys[0]];
        }

        if (localizeObj == null)
            return "";

        return localizeObj[name] ? localizeObj[name] : "";
    }

    const validator = () => {
        const newState = { ...state };

        if (clientRef.current) {
            const clientErrors = context.validateElement(clientRef.current, {}, clientRef.current.value);
            newState.clientIsInvalid = clientErrors && clientErrors.length > 0;
        }
        else {
            newState.clientIsInvalid = false;
        }

        if (formRef.current) {
            const formErrors = context.validateElement(formRef.current, {}, formRef.current.value);
            newState.formIsInvalid = formErrors && formErrors.length > 0;
        }
        else {
            newState.formIsInvalid = false;
        }

        setState(newState);

        if (termsChanged)
            termsChanged(!newState.clientIsInvalid && !newState.formIsInvalid);
    }

    const hasClientTerms = getLocalizeValue(data.clientTerms, i18n.language, "id").length > 0;
    const hasFormTerms = getLocalizeValue(data.formTerms, i18n.language, "id").length > 0;

    useEffect(() => {
        context.validators.subscribe(validator);
        return () => context.validators.unsubscribe(validator);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context, clientRef, formRef]);

    return (
        <>
            {(hasFormTerms || hasClientTerms) &&
                <>
                    <hr></hr>
                    <div className="section white">
                        <div className="section-body">
                            {hasClientTerms &&
                                <div className="custom-control custom-checkbox">
                                    <input
                                        ref={clientRef}
                                        type="checkbox"
                                        autoComplete="off"
                                        className={"custom-control-input" + (state.clientIsInvalid ? " is-invalid" : "")}
                                        disabled={props.disabled}
                                        id="clientTerm"
                                        name="clientTerm"
                                        onBlur={validator}
                                        onChange={validator}
                                        onFocus={validator}
                                        required="required"
                                    />
                                    <label className="custom-control-label" htmlFor="clientTerm">{t("consent:clientTerm")} <Link target="_blank" to={`/${clientKey}/terms/${getLocalizeValue(data.clientTerms, i18n.language, "id")}`}>{getLocalizeValue(data.clientLocalizations, i18n.language, "name")}</Link> <span className="asterisk"> *</span></label>
                                </div>
                            }
                            {hasFormTerms &&
                                <div className="custom-control custom-checkbox">
                                    <input
                                        ref={formRef}
                                        type="checkbox"
                                        autoComplete="off"
                                        className={"custom-control-input" + (state.formIsInvalid ? " is-invalid" : "")}
                                        disabled={props.disabled}
                                        id="formTerm"
                                        name="formTerm"
                                        onBlur={validator}
                                        onChange={validator}
                                        onFocus={validator}
                                        required="required"
                                    />
                                    <label className="custom-control-label" htmlFor="formTerm">{t("consent:formTerm")} <Link target="_blank" to={`/${props.clientKey}/forms/${props.formKey}/terms/${getLocalizeValue(data.formTerms, i18n.language, "id")}`}>{getLocalizeValue(data.templateLocalizations, i18n.language, "name")}</Link> <span className="asterisk"> *</span></label>
                                </div>
                            }
                        </div>
                    </div>
                </>
            }
        </>
    );
}